import Joyride, { CallBackProps } from 'react-joyride';
import React, { useEffect, useRef, useState } from 'react';
import { useMatches, useSearchParams } from 'react-router-dom';
import { RouteItemType } from 'routes';
import AppTour from 'app/tour/AppTour';
import { TourContext, TourStatus } from 'app/tour/index';
import TourToolTip from 'app/tour/TourToolTip';
import { TourRouteMap } from 'app/tour/app-tours';

function updateCustomSpotlight(targetElement: HTMLElement) {
    const spotlight = document.querySelector<HTMLElement>('.react-joyride__spotlight');

    if (targetElement && spotlight) {
        const rect = targetElement.getBoundingClientRect();
        spotlight.style.position = 'fixed';
        spotlight.style.top = `${rect.top - 2}px`;
        spotlight.style.left = `${rect.left - 2}px`;
        spotlight.style.width = `${rect.width + 5}px`;
        spotlight.style.height = `${rect.height + 5}px`;
    }
}

export default function TourManager() {
    const matches = useMatches();

    const [routeUid, setRouteUid] = useState<string | false>(false);
    useEffect(() => {
        if (matches?.length) {
            const uid: string | false = (matches[matches.length - 1].handle as RouteItemType)?.routeUid ?? false;
            setRouteUid(uid);
        } else {
            setRouteUid(false);
        }
    }, [matches]);

    const spotlightFix = (data: CallBackProps) => {
        if (data.action === 'update' && data.step.target) {
            const targetElement =
                typeof data.step.target === 'string'
                    ? document.querySelector<HTMLElement>(data.step.target)
                    : data.step.target;
            if (targetElement) {
                updateCustomSpotlight(targetElement);
            }
        }
    };

    const activeTour = useRef<AppTour>();
    const [tourStatus, setTourStatus] = useState<TourStatus>();
    useEffect(() => {
        if (routeUid == false) {
            return;
        }

        const tourClass = TourRouteMap.get(routeUid);
        if (tourClass) {
            // TODO: fix this
            activeTour.current = new tourClass(setTourStatus);
        }
    }, [routeUid]);

    useEffect(() => {
        if (!activeTour.current) {
            return;
        }
        activeTour.current.startTour();
    }, [activeTour.current]);

    const handleCallback = (data: CallBackProps) => {
        spotlightFix(data);
        if (!activeTour.current) {
            return;
        }
        if (data.action == 'close') {
            activeTour.current.endTour();
            return;
        }
    };

    // TODO: temporary show tour only if there is 'tour' query param
    const params = useSearchParams();
    if (!params[0].has('tour')) {
        return null;
    }

    return (
        <TourContext.Provider value={activeTour.current}>
            <Joyride
                callback={handleCallback}
                run={tourStatus?.isActive ?? false}
                stepIndex={tourStatus?.stepIndex ?? 0}
                scrollOffset={64}
                scrollToFirstStep
                disableOverlayClose
                disableOverlay
                spotlightPadding={0}
                tooltipComponent={TourToolTip}
                steps={tourStatus?.steps ?? []}
                styles={{ options: { zIndex: 10000 } }}
            />
        </TourContext.Provider>
    );
}
